import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles<string, { isLarge: boolean }>(
  ({ breakpoints }: ITheme) => ({
    root: {
      width: '100%',
    },
    textLarge: {
      fontWeight: 700,
      fontSize: 20,
      lineHeight: '28px',
      marginBottom: 20,
      textAlign: 'center',
    },

    textNormal: {
      color: '#999',
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '20px',
      textAlign: 'left',

      [mediaQuery(breakpoints.mobile)]: {
        marginBottom: 8,
      },
    },
  }),
  { name: 'ldr' },
);

export default useStyles;
